import { useQuery } from "@tanstack/react-query";
import { getPostTags } from "../../../api/apiBlog";
import i18next from "i18next";

export const useGetPostTags = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["post-tags", params, i18next.language],
        queryFn: () => getPostTags(params),
        keepPreviousData: true,
    });

    return {
        tags: data?.data || [],
        meta: data?.meta,
        isLoading,
        error,
        refetch,
    };
};
